/** Položka stránkování — číslo stránky nebo ellipsis. */
export type PaginationItem = number | 'ellipsis';

export function getTotalPages(totalItems: number, itemsPerPage: number): number {
  const limit = Math.max(1, itemsPerPage);
  return Math.max(1, Math.ceil(Math.max(0, totalItems) / limit));
}

/** Čísla stránek s ellipsis (stejná logika jako seznam Objektů). */
export function getPaginationItems(
  currentPage: number,
  totalItems: number,
  itemsPerPage: number,
): PaginationItem[] {
  const totalPages = getTotalPages(totalItems, itemsPerPage);
  const items: PaginationItem[] = [];

  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i++) items.push(i);
    return items;
  }

  const page = Math.min(Math.max(1, currentPage), totalPages);
  let windowStart = Math.max(2, page - 2);
  let windowEnd = Math.min(totalPages - 1, page + 2);
  if (page <= 4) windowEnd = Math.min(totalPages - 1, 6);
  if (page >= totalPages - 3) windowStart = Math.max(2, totalPages - 5);

  items.push(1);
  if (windowStart > 2) items.push('ellipsis');
  for (let i = windowStart; i <= windowEnd; i++) items.push(i);
  if (windowEnd < totalPages - 1) items.push('ellipsis');
  items.push(totalPages);
  return items;
}

/** Ořízne aktuální stránku do platného rozsahu po změně filtrů / total. */
export function clampPage(currentPage: number, totalItems: number, itemsPerPage: number): number {
  const totalPages = getTotalPages(totalItems, itemsPerPage);
  return Math.min(Math.max(1, currentPage), totalPages);
}
